import { RootState } from "redux/rootReducer";

export const selectIsDownloadingMiniStressPDF = (state: RootState) =>
  state.miniStressPdfDownload.loading;
export const miniStressPdfDownloadErrorMessage = (state: RootState) =>
  state.miniStressPdfDownload.error;
export const miniStressPdfDownloadSuccessResponse = (state: RootState) =>
  state.miniStressPdfDownload.miniStressPdfDownloadResponse;
